export const BaseURL = "https://bakiz.monibbormon.xyz/api/v1";
// export const BaseURL="https://bakiz-server.onrender.com/api/v1";
// export const BaseURL="http://localhost:8080/api/v1";
